export const FEATURE_REMINDER_SCREENS = {
  DASHBOARD: 'web-dashboard',
  HOST_EVENT_PAGE: 'web-host-event-page'
};

export const FEATURES = {
  DISCOUNT_CODES: 'discount-codes',
  EVENT_ASPECT_RATIO: 'event-aspect-ratio',
  TERMS_UPDATE: 'terms-update'
};
